module.exports = __webpack_public_path__ + "static/media/5DPO17.f273d8e4.jpg";